"use client";

import React from "react";

import { PopoverContext } from "./PopoverContext";
import type { IPopoverOptions } from "./types";
import { usePopoverContextValue } from "./usePopoverContextValue";

type IProps = IPopoverOptions;

export const PopoverRoot: React.FC<React.PropsWithChildren<IProps>> = ({
  children,
  ...contextOptions
}) => {
  const value = usePopoverContextValue(contextOptions);

  return <PopoverContext value={value}>{children}</PopoverContext>;
};
